
import { CiudadService } from './../services/ciudad.service';
import { Component, Input, ViewChild } from '@angular/core';
import { ConfirmationService, MessageService } from 'primeng/api';
import { Table } from 'primeng/table';
import { AuthService } from '../services/auth.service';
import ICredencialUsuario from '../models/credencial';
import { ICiudad } from '../models/ciudad';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import * as saveAs from 'file-saver';
import { IConMantenimiento } from '../models/consultaMantenimiento';
import { UnidadtransporteService } from '../services/unidadtransporte.service';

@Component({
  selector: 'app-mmto',
  templateUrl: './mmto.component.html',
  styleUrls: ['./mmto.component.scss']
})
export class MmtoComponent {
  @ViewChild('dt1') dt!: Table;
  dia: any = new Date().toISOString().substring(0, 10);

  user: ICredencialUsuario = {};
  lstCiudades: ICiudad[] = [];
  selectedCiudad: ICiudad = {
    id: 0,
    nombre: '',
    clave_Estado: '',
    id_ciudad_principal: 0
  };

  // clv_permiso:boolean= false;
  num_economico: string = '';
  kilometraje_nuevo: number = 0;
  id_estatus_unidad: number = 0;
  kilometraje_anterior: number = 0;
  dspOpenHis: boolean = false;
  dspAgregar: boolean = false
  loading: boolean = false;
  fec_gestionKilometraje: string = ''
  fec_inicio: string = ''
  fec_fin: string = ''
  clv_operacion: number = 0;
  lstgestionkilometraje: any;
  dspEditar: boolean = false;
  datos: boolean = false

  dspMantenimiento: boolean = false;
  lstManteniento: IConMantenimiento[] = [];
  loadingManetnimiento:boolean = false;
  loadingManetnimiento_reporte:boolean = false;
  loading_reporte: boolean = false;
  desHabilitarBotones: boolean = true;
  lstRpt: any = []
  consMantenimientoForm: FormGroup = new FormGroup({
    id_ciudad_hm: new FormControl(null, [Validators.required])
  });
  ngOnInit(): void {
    this.cargarListadoCiudades();
    this.inicializarFechasFormateadas();
    const today = new Date();
    this.fec_inicio = today.toISOString().substring(0, 10)
    this.fec_fin = today.toISOString().substring(0, 10)
    // this.reactiveform.controls['fec_gestionKilometraje'].setValue(today.toISOString().substring(0, 10))
  }
  cargarInformacionUsuario() {
    this.user = this.auth.user;
  }

  constructor(
    private confirmationService: ConfirmationService,
    private messageService: MessageService,
    private auth: AuthService,
    private ciudadService: CiudadService,
    private unidadService: UnidadtransporteService,
  ) {
    this.cargarInformacionUsuario();
  }


  reactiveform: FormGroup = new FormGroup({
    idx: new FormControl(0),
    id_unidad_transporte: new FormControl(0),
    num_economico: new FormControl('', [Validators.required]),
    fec_gestionKilometraje: new FormControl('', [Validators.required]),
    kilometraje_anterior: new FormControl(0),
    kilometraje_nuevo: new FormControl(0, [Validators.required]),
    id_ciudad: new FormControl(0),
    desc_ciudad: new FormControl(''),
    clave_configuracionUnidad: new FormControl(0),
    clv_estatus: new FormControl(0),
    desc_estatus: new FormControl(''),
    id_estatus_unidad: new FormControl(0, [Validators.required]),

  })

  getMantenimiento() {
    this.loadingManetnimiento = true;
    const ciudad = this.consMantenimientoForm.controls['id_ciudad_hm'].value;
    if ( ciudad == null) {
      this.messageService.add({
        key: 'msj',
        severity: 'info',
        summary: 'Advertencia',
        detail: 'Es necesario seleccionar Ciudad para cargar la información.'
      });
      this.loadingManetnimiento = false;
      return;
    };
    this.lstManteniento = [];
    this.unidadService.getConsultaMantenimiento(ciudad).subscribe((resp) => {
      this.lstManteniento = resp;
      setTimeout(() => {
        this.loadingManetnimiento = false;
      }, 500);
    }, (error) => {
      this.loadingManetnimiento = false;

      this.mostrarDialogoInformativoSinInformacion('<b>Error al obtener listado de Mantenimiento</b>. de servicios sin informacion.');
    });
  }

  exportarExcelMantenimiento(){
   this.loadingManetnimiento_reporte = true;
    const ciudad = this.consMantenimientoForm.controls['id_ciudad_hm'].value;
    // Descomponer la fecha manualmente para evitar el desfase por UTC
    const fecha = new Date()
    const fechaSTR = fecha.toISOString().substring(0, 10);
    //const [year, month, day] = fecha.split('-').map(Number);
    //const fechaObj = new Date(year, month - 1, day); // Fecha correcta en hora local

    // const fechaObj = new Date(fecha);

    if ( !fecha || ciudad == null||  isNaN(fecha.getTime())) {
      this.messageService.add({
        key: 'msj',
        severity: 'info',
        summary: 'Advertencia',
        detail: 'Es necesario seleccionar Ciudad y Fecha para generar el reporte.'
      });
      this.loadingManetnimiento_reporte = false;
      return;
    };
    this.unidadService.getrptConsultaMantenimiento(this.consMantenimientoForm.controls['id_ciudad_hm'].value)
    .subscribe((resp: any[]) => {
      if (resp.length === 0 || typeof resp === 'undefined') {
        this.mostrarDialogoInformativoSinInformacion('<b>Aviso</b> No existe informacion del Catalogo para exportar(Excel)');
        this.loadingManetnimiento_reporte = false;
      } else {
        import("xlsx").then(xlsx => {
          const worksheet = xlsx.utils.json_to_sheet(resp);
          const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
          const excelBuffer: any = xlsx.write(workbook, {
            bookType: "xlsx",
            type: "array"
          });
          this.saveAsExcelFile(excelBuffer, "ReporteEstatusMantenimiento");
          // this.saveAsExcelFile(excelBuffer, "ReporteEstatusMantenimiento" + '_'+fechaFormateada+'_AlDia_'+fechaCasteada);
        });
        setTimeout(() => {

          this.loadingManetnimiento_reporte = false;
        }, 1000);
      }
    },
      (error) => {
        this.loadingManetnimiento_reporte = false;
        this.messageService.add({ key: 'msj', severity: 'error', summary: 'Error', detail: 'Error en emitir el reporte de Estatus de Mantenimiento.' });
      });
  }


  cancelarModal() {
    this.dspAgregar = false;
    this.reactiveform.controls['kilometraje_anterior'].reset();
    this.reactiveform.controls['num_economico'].reset();
    this.reactiveform.controls['kilometraje_nuevo'].reset();
    this.reactiveform.controls['id_estatus_unidad'].reset();
    this.reactiveform.controls['fec_gestionKilometraje'].setValue(new Date().toISOString().substring(0, 10)
    )
  }

  fec_hoy: string =''

  cargarListadoCiudades() {
    this.ciudadService.getListadoCiudades().subscribe((resp) => {
      this.lstCiudades = resp;
      setTimeout(() => {}, 800);
    },
      (error) => {
        this.messageService.add({ severity: 'error', summary: 'Error en cargar <Ciudades>', detail: 'Contacte al Administrador del Sitio' });
      });
  }

  inicializarFechasFormateadas() {
    var getYear = new Date().toLocaleDateString('es-MX', { year: 'numeric' });
    var getMonth = new Date().toLocaleDateString('es-MX', { month: '2-digit' });
    var getDay = new Date().toLocaleDateString('es-MX', { day: '2-digit' });
    var dateFormat = getYear + "-" + getMonth + "-" + getDay;
  }

  mostrarDialogoInformativoSinInformacion(mensaje_usuario: string) {
    let mensaje_completo = mensaje_usuario ;
    this.confirmationService.confirm({
      message: mensaje_completo,
      header: 'Informativo',
      icon: 'pi pi-info-circle',
      accept: () => {
        this.messageService.add({ key: 'msj', severity: 'info', summary: 'Confirmación', detail: 'Usuario informado de la situación.' });
      },
      reject: () => {
        this.messageService.add({ key: 'msj', severity: 'info', summary: 'Confirmación', detail: 'Usuario informado de la situación.' });
      },
      key: "sinInformacionDialog"
    });
    this.loading = false;
  }

  mostrarDialogoInformativo(mensaje_usuario: string) {
    let mensaje_completo = mensaje_usuario + '.';
    this.confirmationService.confirm({
      message: mensaje_completo,
      header: 'Informativo',
      icon: 'pi pi-info-circle',
      accept: () => {
        this.messageService.add({ key: 'msj', severity: 'info', summary: 'Confirmación', detail: 'Usuario informado de la situación.' });
        this.messageService.clear();
      },
      reject: () => {
        this.messageService.add({ key: 'msj', severity: 'info', summary: 'Confirmación', detail: 'Usuario informado de la situación.' });
        this.messageService.clear();
      },
      key: "sinInformacionDialog"
    });
    this.loading = false;
    this.messageService.clear();
  }
  saveAsExcelFile(buffer: any, fileName: string): void {
    //var FileSaver = require('file-saver');
    var getYear = new Date().toLocaleDateString('es-MX', { year: 'numeric' });
    var getMonth = new Date().toLocaleDateString('es-MX', { month: '2-digit' });
    var getDay = new Date().toLocaleDateString('es-MX', { day: '2-digit' });
    var dateFormat = getYear + "-" + getMonth + "-" + getDay;
    let EXCEL_TYPE =
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
    let EXCEL_EXTENSION = ".xlsx";
    const data: Blob = new Blob([buffer], {
      type: EXCEL_TYPE
    });
    saveAs(data, fileName + "_export_" + dateFormat + EXCEL_EXTENSION);
  }

  limpiarFiltrosTabla() {
    this.dt.clear();
  }
  /*Filtro General para la informacion de tabla*/
  applyFilterGlobal($event: any, stringVal: any) {
    this.dt.filterGlobal(($event.target as HTMLInputElement).value, stringVal);
  }
}
